import { Component, HostBinding } from '@angular/core';
import { AlignmentViewerPanelComponent } from './components';

@Component({
  imports: [AlignmentViewerPanelComponent],
  selector: 'nzc-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  @HostBinding('class') componentClasses = 'flex flex-col grow h-full bg-white';
}
